import { render, staticRenderFns } from "./ScreenComparativaPromedios.vue?vue&type=template&id=37a5f0dc&scoped=true"
import script from "./ScreenComparativaPromedios.vue?vue&type=script&lang=js"
export * from "./ScreenComparativaPromedios.vue?vue&type=script&lang=js"
import style0 from "./ScreenComparativaPromedios.vue?vue&type=style&index=0&id=37a5f0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5f0dc",
  null
  
)

export default component.exports